var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRwf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 32,
    height: 24,
    viewBox: "0 0 55.2 38.4",
    style: {
      enableBackground: "new 0 0 55.2 38.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .st0{fill:#20603D;}\r\n    .st1{fill:#FAD201;}\r\n    .st2{fill:#00A1DE;}\r\n    .st3{fill:#E5BE01;}\r\n    .st4{fill:#E5BE01;stroke:#00A1DE;stroke-width:0.3869;stroke-miterlimit:2.6131;}\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.01,0h49.17c1.66,0.01,3.01,1.37,3.01,3.03v32.33c0,1.67-1.36,3.03-3.03,3.03l-49.15,0       C1.35,38.39,0,37.03,0,35.37V3.03C0,1.37,1.35,0.01,3.01,0L3.01,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.01,0h49.17c1.66,0.01,3.01,1.37,3.01,3.03V28.8H0V3.03C0,1.37,1.35,0.01,3.01,0L3.01,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.01,0h49.17c1.66,0.01,3.01,1.37,3.01,3.03V19.2H0V3.03C0,1.37,1.35,0.01,3.01,0L3.01,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "52.27,10.03 47.98,10.28 52.06,11.63 47.85,10.77 51.44,13.13 47.6,11.2        50.46,14.41 47.25,11.56 49.18,15.39 46.81,11.81 47.68,16.01 46.33,11.94 46.08,16.22 46.03,9.98 52.27,10.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "52.27,10.03 47.98,9.78 52.06,8.43 47.85,9.3 51.44,6.94 47.6,8.86        50.46,5.65 47.25,8.51 49.18,4.67 46.81,8.26 47.68,4.05 46.33,8.13 46.08,3.84 46.03,10.09 52.27,10.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "39.89,10.03 44.18,10.28 40.1,11.63 44.31,10.77 40.72,13.13 44.56,11.2        41.7,14.41 44.91,11.56 42.98,15.39 45.34,11.81 44.48,16.01 45.83,11.94 46.08,16.22 46.13,9.98 39.89,10.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "39.89,10.03 44.18,9.78 40.1,8.43 44.31,9.3 40.72,6.94 44.56,8.86        41.7,5.65 44.91,8.51 42.98,4.67 45.34,8.26 44.48,4.05 45.83,8.13 46.08,3.84 46.13,10.09 39.89,10.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.91,10.03c0-1.01-0.82-1.83-1.83-1.83c-1.01,0-1.83,0.82-1.83,1.83       c0,1.01,0.82,1.83,1.83,1.83C47.09,11.86,47.91,11.04,47.91,10.03L47.91,10.03z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwf);
export default __webpack_public_path__ + "static/media/rwf.40f423b2f1c3c7b52f2dfd88cfb47e03.svg";
export { ForwardRef as ReactComponent };